//region header
//--------------------------------------------------------------------------------------------------
//
//  Description: Homepage Control containing dashboard information
//
//  Copyright:    © 2021 - 2025 Idox Software Limited.
//
//--------------------------------------------------------------------------------------------------
//
//  Modification History:
//
//  Version Date     Modifier             Issue# Description
//region Version 1.0.0.0
//    001   02.06.23 Joel Benford        WI40689 Initial Revision.
//    002   07.09.23 Sean Flook                  Modified function name.
//    003   06.10.23 Sean Flook                  Use colour variables.
//    004   24.11.23 Sean Flook                  Moved Box to @mui/system.
//    005   02.01.24 Sean Flook                  Changed console.log to console.error for error messages.
//    006   05.01.24 Sean Flook                  Changes to sort out warnings.
//    007   25.01.24 Sean Flook                  Correctly handle status code 204.
//    008   19.06.24 Sean Flook        IMANN-629 Changes to code so that current user is remembered and a 401 error displays the login dialog.
//    009   10.09.24 Sean Flook        IMANN-980 Only write to the console if the user has the showMessages right.
//endregion Version 1.0.0.0
//region Version 1.0.5.0
//    010   27.01.25 Sean Flook       IMANN-1077 Upgraded MUI to v6.
//    011   30.01.25 Sean Flook       IMANN-1673 Changes required for new user settings API.
//    012   19.02.25 Sean Flook       IMANN-1077 Added a Box around the grid.
//    013   28.05.25 Sean Flook       IMANN-1800 Moved the getting of the data to the HomePage so this control in not displayed until we have the data.
//endregion Version 1.0.5.0
//region Version 1.0.7.0
//    014   28.08.25 Sean Flook       IMANN-1812 Changes required to update MUI to v7.
//endregion Version 1.0.7.0
//
//--------------------------------------------------------------------------------------------------
//endregion header

import React from "react";

import { Grid } from "@mui/material";
import ADSHomepagePieChartsControl from "./ADSHomepagePieChartsControl";
import ADSHomepageLatestEditsControl from "./ADSHomepageLatestEditsControl";

import { adsMidGreyA10 } from "../utils/ADSColours";
import { Box } from "@mui/material";
import { dataFormStyle } from "./../utils/ADSStyles";

function ADSHomepageControl({ data }) {
  return (
    <Box sx={dataFormStyle("ADSHomepageControl")}>
      <Grid
        container
        direction="column"
        justify="center"
        alignItems="center"
        spacing={4}
        sx={{ pt: "10px", backgroundColor: adsMidGreyA10 }}
      >
        <Grid>
          <ADSHomepagePieChartsControl data={data.pieCharts} />
        </Grid>
        <Grid alignItems="bottom">
          <ADSHomepageLatestEditsControl data={data.latestStreetAndPropertyEdits} />
        </Grid>
      </Grid>
    </Box>
  );
}

export default ADSHomepageControl;
